export const ComponentColumn = (props: any) => {
  return props.children;
};
